import { useQuery } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';
import { convertArticleItem } from '@/shared/utils';

interface AuthorArticleQueryParams {
  authorId: number;
  ordering?: 'latest' | 'popular';
  page?: number;
  pageSize?: number;
}

const useAuthorArticleQuery = ({
  authorId,
  ordering,
  page,
  pageSize,
}: AuthorArticleQueryParams) => {
  return useQuery({
    queryKey: ['authorArticle', authorId, ordering, page, pageSize],
    queryFn: async () => {
      const { data } = await clientAxios.get('/authorArticleListApi/', {
        params: { authorId, ordering, page, pageSize },
      });

      return {
        maxPage: Math.ceil(data.data.count / 10),
        articles: convertArticleItem(data.data.results),
      };
    },
  });
};

export default useAuthorArticleQuery;
